import React, { Component } from 'react'
import {
  Grid,
  Table,
  TableHeaderRow,
  TableGroupRow,
  TableSelection
} from '@devexpress/dx-react-grid-bootstrap4'
import {
  IntegratedGrouping,
  GroupingState,
  SelectionState,
  IntegratedSelection
} from '@devexpress/dx-react-grid'

class GrillaCallesDeCaladoEgreso extends Component {
  selectableRow (props) {
    const { ...restProps } = props
    return props.row.estadoAutorizacion === 'Pendiente' ? <Table.StubCell /> : <TableSelection.Cell {...restProps} />
  }

  getTableComponent () {
    return ({ ...restProps }) => (
      <Table.Table
        {...restProps}
        className='table-striped'
      />)
  }

  render () {
    const {
      rows,
      onSelectionChange,
      egresosSeleccionados
    } = this.props
    const columns = [
      { name: 'calleDeCalado', title: 'Calle' },
      { name: 'orden', title: 'Orden' },
      { name: 'descripcionEstadoCalle', title: 'Ubicacion' },
      { name: 'cereal', title: 'Cereal' },
      { name: 'cerealVariedad', title: 'Cereal Variedad' },
      // { name: 'totalEnCalle', title: 'Ocupado' },
      // { name: 'libre', title: 'Libre' },
      { name: 'cartaDePorteAutomotor', title: 'CPA' },
      { name: 'camion', title: 'Camion' },
      { name: 'estadoProceso', title: 'Estado Proceso' },
      { name: 'calificacionCereal', title: 'Calificacion Cereal' },
      { name: 'calificacionCerealDos', title: 'Calificacion Cereal 2' },
      { name: 'estadoAutorizacion', title: 'Estado Autorización' },
      { name: 'fechaAsignacionCalleDeCalado', title: 'Fecha' }
    ]

    return (
      <div className='grilla-calado' >
        <Grid
          showBorders
          rows={rows}
          columns={columns}
        >
          <SelectionState />
          <GroupingState
            grouping={[{ columnName: 'descripcionEstadoCalle' }]}
          />
          <IntegratedGrouping />
          <SelectionState
            selection={egresosSeleccionados}
            onSelectionChange={onSelectionChange}
          />
          <IntegratedSelection />
          <Table
            tableComponent={this.getTableComponent()}
          />
          <TableSelection
            showSelectAll
            highlightRow
            cellComponent={this.selectableRow}
          />
          <TableHeaderRow />
          <TableGroupRow />
        </Grid>
      </div>
    )
  }
}

export default GrillaCallesDeCaladoEgreso
